import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import NewFicheForm from "../../../components/Forms/Fiche/NewFicheForm";
import {useParams, useHistory, Link} from 'react-router-dom'
import axios from 'axios'
import ProgressBar from "react-bootstrap/ProgressBar";
import {
    CONFIRM_EMAIL,
    SEARCH_FICHE_BY_FORM_CODE,
    UNAUTHENTICATED_CONFIRM_EMAIL,
    UPDATE_USER_PASSWORD,
    VALIDATE_USER_EMAIL
} from "../../../api/Api";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Field, Formik} from "formik";
import TextField from "../../../components/Ui/TextField";
import Button from "@material-ui/core/Button";
import * as Yup from 'yup'
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import {useDispatch, useSelector} from "react-redux";
import {actions, actions as authActions} from "../../../modules/Auth/_redux/authRedux";
import {toast} from "react-toastify";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1, 1)
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(5, 12)
        },
        [theme.breakpoints.up('lg')]: {
            padding: theme.spacing(10, 20)
        },
    },
    table: {
        minWidth: 700,
    },
}));


const ValidationSchema = Yup.object().shape({
    code: Yup.string()
        .required('Champs obligatoire')

});


export default function (props) {

    const {user} = useSelector(state => state.auth);
    const dispatcher = useDispatch()

    const {code} = useParams();

    const [responseError, setResponseError] = React.useState();

    const history = useHistory();

    const [isConfirming, setIsConfirming] = React.useState(false)

    async function confirmEmail() {

        setResponseError()

        try {

            setIsConfirming(true)

            const response = (await axios.post(
                UNAUTHENTICATED_CONFIRM_EMAIL,
                {
                    code
                }
            ));

            if (response.status === 200) {


        toast.success('Votre adresse email a été confirmer avec succès', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });  
        


                if(user) {
                    dispatcher(actions.fulfillUser(response.data))
                }

                history.push('/auth/login')

            } else {
                console.log('Some error happened when updating')
                //Display some error toast
            }


        } catch (e) {

            setResponseError(e)

        } finally {
            setIsConfirming(false)
        }

    }

    React.useEffect(
        () => {
            confirmEmail()
        }, []
    );

    return (
        <div className="d-flex flex-column flex-root">
            {/*begin::Login*/}
            <div
                className="login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
                id="kt_login"
            >

                {/*begin::Content*/}
                <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">
                    {/*begin::Content header*/}
                    {/*<div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">*/}
                    {/*  <span className="font-weight-bold text-dark-50">Don't have an account yet?</span>*/}
                    {/*  <Link to="/auth/registration" className="font-weight-bold ml-2" id="kt_login_signup">Sign Up!</Link>*/}
                    {/*</div>*/}
                    {/*end::Content header*/}

                    {/* begin::Content body */}
                    <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">


                        {
                            isConfirming && (
                                <div className={'h1 text-muted font-weight-lighter'}>
                                    Veuillez patienter pendant la confirmation de votre <span
                                    className={'text-primary font-weight-bold'}>adresse email</span>

                                    <CircularProgress/>


                                </div>
                            )
                        }

                        {

                            responseError && responseError.response && (

                                <div>

                                    <div className={'h1 text-danger font-weight-lighter'}>
                                        {responseError.response.data.errors.message}
                                    </div>

                                </div>

                            )

                        }

                    </div>
                    {/*end::Content body*/}

                </div>
                {/*end::Content*/}
            </div>
            {/*end::Login*/}
        </div>
    );


}